import React, { useEffect, useState } from "react";
import logo from './logo.png';
import sit from './sitt.png';
import email from './email.png';
import linked from './linke.png';
import face from './oma.png';
import anc from './iconn.png';
import "./App.css";

function App() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className="App">
            {/* Header */}
            <header className={`header ${scrolled ? "scrolled" : ""}`}>
                <div className="name"><span>Web developer</span><span>Jyri Huuhtanen</span></div>
                <img src={logo} className="logo" alt="logo" />
            </header>

            {/* Lander Section */}
            <div className="lander">
                <div className="wrap">
                    <img src={sit} className="landerlogo" alt="sitting" />
                    <div className="lander-text">Jyri Huuhtanen - Web developer</div>
                        <h1>Crafting seamless digital <br></br> experiences from Helsinki</h1>

                </div>

            </div>

            {/* Section */}
            <div className="section">
                <div className="section-text">
                    I am a 37-year-old web developer from the metropolitan area.
                    I design and build websites. I graduated from Häme University of Applied Sciences in 2017 with a degree in Information Technology Business.
                    <br></br>
                    <br></br>
                    With nearly a decade of experience in web development, I have always been interested in programming and I constantly strive to learn new things and improve as a web developer in both back-end and front-end development.
                    <br></br>
                    <br></br>
                    My specialty is the WordPress publishing system and its add-ons and integrations,
                    creating dynamic websites and Web Apps.
                    <br></br>
                    <br></br>
                    In my free time I like to cycle and hike with my family.
                </div>
                <img src={anc} className="anchor" alt="anchor" />
            </div>

            {/* Footer */}
            <div className="footer">
                <div className="footer-text">
                    <img src={face} className="face" alt="face" />
                    <h2>Contact me</h2>
                    <div className="some-bottom">
                        <a href="mailto:info@jyrihuuhtanen.fi"> <img src={email} className="icon" alt="email" /></a><a href="https://www.linkedin.com/in/jyrihuuhtanen"><img src={linked} className="icon" alt="linked" /></a>
                </div>
                </div>
            </div>
            <div className="copyr"><p>Jyri Huuhtanen 2025 <span>©</span></p></div>
        </div>
    );
}

export default App;
